<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <smx-trade-generation
          :auth-token="authToken"
          :environment="envLocal"
          :parent-environment="clientEnvironment"
          :remote-style-url="remoteStyleUrl"
          @click:acr-row="onClick"
          @click:acr-submit="onSubmit"
        />
      </v-col>
    </v-row>

    <v-snackbar v-model="showSnackbar">
      <v-icon color="success">check</v-icon>
      {{ submitMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      env: '',
      showSnackbar: false,
      submitMessage: '',
      clientEnvironment: '',
      authToken: ''
    }
  },
  created () {
    this.env = process.env.VUE_APP_ENV

    // Magic number that depicts parent env for the trade generation ui component
    this.clientEnvironment = '1abc4124fa0e'

    this.authToken = `Bearer ${localStorage.getItem('token')}`
  },
  computed: {
    envLocal () {
      return this.env === 'production' ? 'live' : this.env
    },
    baseUrl () {
      return this.$store.getters.appEnv.cdn_base_url
    },
    remoteStyleUrl () {
      return `${this.baseUrl}/css/smartx.css`
    }
  },
  methods: {
    onClick ({ detail }) {
      const [allocation] = detail
      if (allocation?.allocationId) {
        this.$router.push(`/allocations/${allocation.allocationId}/overview`)
      }
    },
    onSubmit ({ detail }) {
      const [message] = detail
      this.showSnackbar = true
      this.submitMessage = `ACR ${message}`
    }
  }
}
</script>
